import React, { useState } from "react"
import { useLabels } from "components/general/Label";
import { useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import { createClickableLink } from "helpers/utils";
import Noc from "components/presentation/Noc";
import { usePathPhotoOrDefault } from "helpers/utils";
import { Link } from "react-router-dom";



const NocProfileTable = ({ data }) => {
  //Prepare URL to navigate
  const { mirs_language } = useUrlFriendlyToParameters()
  const fLabel = useLabels()

  if (mirs_language !== "ENG") return (<h2>
    {fLabel({ data: 'LabelExtendedProfile' })}
  </h2>);
  return (<>
    <div className="NocProfileTable-Container">
      <h2 id="GeneralInterest">
        {fLabel({ data: 'HeaderGeneralInterest' })}
      </h2>
      {data?.nocBio?.interest?.highlights && <p>
        <b>{fLabel({ data: 'HeaderHighlights' })}</b>
      </p>}
      <p dangerouslySetInnerHTML={{ __html: data?.nocBio?.interest?.highlights }}></p>

      {data?.nocBio?.interest?.addInformation && (<>
        <p><b>{fLabel({ data: 'HeaderAddInformation' })}</b></p>
        <div dangerouslySetInnerHTML={{ __html: createClickableLink(data?.nocBio?.interest?.addInformation) }}></div>
      </>)}

      <div className="wrsNoc" ></div>

     {data?.nocBio?.anthem && <h2 id="Anthem">
        {fLabel({ data: 'HeaderAnthem' })}
      </h2>}
      <p>
        {data?.nocBio?.anthem?.title && (<> <b>{fLabel({ data: 'HeaderTitle' })}</b>: {data?.nocBio?.anthem?.title}<br /> </>)}
        {data?.nocBio?.anthem?.composer && (<> <b>{fLabel({ data: 'HeaderComposer' })}</b>: {data?.nocBio?.anthem?.composer}<br /></>)}
        {data?.nocBio?.anthem?.inducted && (<> <b>{fLabel({ data: 'HeaderInducted' })}</b>: {data?.nocBio?.anthem?.inducted}<br /></>)}
      </p>

      {data?.nocBio?.interest?.ocFlagBearer && <>
        <h2 id="FlagBearer">
          {fLabel({ data: 'HeaderFlagBearer' })}
        </h2>
        <div>
          <FlagBearerList data={data} />
        </div>
      </>
      }
      {data?.nocBio?.membership && <h2 id="Membership">
        {fLabel({ data: 'HeaderMembership' })}
      </h2>}
      <p>
        {data?.nocBio?.membership?.officialNocName && (<> <b>{fLabel({ data: 'HeaderOffNOCName' })}</b>: {data?.nocBio?.membership?.officialNocName}<br /></>)}
        {data?.nocBio?.membership?.countriesIncluded && (<> <b>{fLabel({ data: 'LabelCountriesIncluded' })}</b>: {data?.nocBio?.membership?.countriesIncluded}<br /></>)}
        {data?.nocBio?.membership?.foundingDate && (<> <b>{fLabel({ data: 'LabelFoundingDate' })}</b>: {data?.nocBio?.membership?.foundingDate}<br /></>)}
        {data?.nocBio?.membership?.dateIOCRecognition && (<> <b>{fLabel({ data: 'HeaderIOCRecognition' })}</b>: {data?.nocBio?.membership?.dateIOCRecognition}<br /></>)}
      </p>

      {data?.nocBio?.officials && <h2 id="Officials">
        {fLabel({ data: 'HeaderOfficials' })}
      </h2>}
      <p>
        {data?.nocBio?.officials?.nocPresident && (<> <b>{fLabel({ data: 'HeaderNOCPresident' })}</b>: {data?.nocBio?.officials?.nocPresident}<br /></>)}
        {data?.nocBio?.officials?.nocGenSecretary && (<> <b>{fLabel({ data: 'HeaderNOCGenSecretary' })}</b>: {data?.nocBio?.officials?.nocGenSecretary}<br /></>)}
        {data?.nocBio?.officials?.iocMembers && (<> <b>{fLabel({ data: 'HeaderIOCMembers' })}</b>: {data?.nocBio?.officials?.iocMembers}<br /></>)}
        {data?.nocBio?.officials?.iocExecBoard && (<> <b>{fLabel({ data: 'LabelIOCExecBoard' })}</b>: {data?.nocBio?.officials?.iocExecBoard}<br /></>)}
      </p>

      {data?.nocBio?.participation && <h2 id="Participation">
        {fLabel({ data: 'HeaderParticipation' })}
      </h2>}
      <p>
        {data?.nocBio?.participation?.firstOGAppearance && (<> <b>{fLabel({ data: 'LabelFirstAppearance' })}</b>: {data?.nocBio?.participation?.firstOGAppearance}<br /></>)}
        {data?.nocBio?.participation?.numOGAppearance && (<> <b>{fLabel({ data: 'LabelParticipations' })}</b>: {data?.nocBio?.participation?.numOGAppearance}<br /></>)}
        {data?.nocBio?.participation?.summary && <b>{fLabel({ data: 'LabelSummary' })}</b>}<br />
      </p>

      <p dangerouslySetInnerHTML={{ __html: data?.nocBio?.participation?.summary }}></p>


    </div>
  </>
  )
}

export default NocProfileTable;

export function FlagBearerList({ data }) {
  const ocFlagBearers = data?.nocBio?.ocFlagBearers;
  const interestFlagBearers = data?.nocBio?.interest?.ocFlagBearer;

  const FlagBearer = ({ bearer }) => {
    // uppdate the personal image by the placeholder in case cannot fetch the image.
    const updateURL = (event) => {
      setUrl(placeholderURL);
    };

    let parameters = useUrlFriendlyToParameters();
    const getURL = useGetURL()
    const { mainURL, placeholderURL } = usePathPhotoOrDefault(bearer.code, bearer?.image);
    const [url, setUrl] = useState(mainURL);
    const category = bearer?.mainFunction?.category;
    let page = "";

    if (category === "A") {
      page = "bios";
    } else if (category === "C") {
      page = "coach";
    } else if (category === "J") {
      page = "official";
    }

    //parameters = { ...parameters, mirs_code: bearer.code }
    return (
      <div key={bearer.code} className="flag-bearer-container">
        <div className="flag-bearer-image">
          <img src={url} alt={bearer.code} title={bearer.name} onError={updateURL} />
        </div>
        <div className="flag-bearer-details">
          <Noc {...bearer?.organisation} hasLink={getURL(parameters, 'schedulebynoc')} />
          <Link to={getURL({ ...parameters, mirs_code: bearer.code }, page)}>
            <p className="flag-bearer-name">{bearer.name}</p>
          </Link>
        </div>
      </div>
    );
  };
  return (
    <div className="flag-bearer-list">
      {interestFlagBearers?.map(bearer => {
        // Check if the bearer exists in ocFlagBearers
        const existsFlagBearer = ocFlagBearers && ocFlagBearers.find(ocBearer => ocBearer?.code === bearer);
        return existsFlagBearer ? (
          <FlagBearer key={bearer.code} bearer={existsFlagBearer} />
        ) : (
          <div key={bearer}>{bearer}</div>
        );
      })}
    </div>
  );
}

